<template>
  <section id="internnav" class="zeromp">
    <nav class="navbar internnav">
      <div class="navbar-menu">
        <div class="navbar-end">
          <b-dropdown aria-role="menu" class="profile">
            <button class="button profile-infos" slot="trigger">
              <img v-if="profile_picture !== 'null'" :src="profile_picture" class="profile-picture" />
              <img
                v-else
                src="../../assets/images/icon-color/user.svg"
                alt="Imagem Defaul"
                class="profile-picture"
              />
              <span class="profile-name">{{name}}</span>
              <span class="profile-job">{{cargo}}</span>
            </button>
            <b-dropdown-item
              aria-role="menuitem"
              @click="$router.push({ name: cargo+'/perfil', params: { cargo_id }})"
            >
              <b-icon icon="account" style="position:absolute"></b-icon>
              <p style="margin-left:23px;color:#4a4a4a;">Perfil</p>
            </b-dropdown-item>
            <b-dropdown-item aria-role="menuitem" href="#" v-on:click="logout">
              <b-icon class="icon-sair"></b-icon>Sair
            </b-dropdown-item>
          </b-dropdown>

          <b-dropdown v-if="cargo == 'aluno'" position="is-bottom-left" aria-role="menu" class="notifications">
            <button class="button" slot="trigger">
              <b-icon class="fas fa-bell"></b-icon>
              <span class="badge" v-if="notificacoes.length > 0">{{notificacoes.length}}</span>
            </button>
            <div v-if="notificacoes.length > 0">
              <b-dropdown-item
                class="dropdownNavNoti"
                aria-role="listitem"
                v-for="notificacao in notificacoes"
                :key="notificacao"
                @click="$router.push({ name: 'redacao/update', params: { uuid: notificacao.redacao_id }})"
                >
                  <p>Proposta: {{notificacao.redacao.proposta}}</p>
                  <p>Enviada em: {{notificacao.redacao.created_at}}</p>
                  <p>{{notificacao.texto}}</p>
                  <p>{{notificacao.updated_at}}</p>
              </b-dropdown-item>
            </div>
            <div v-else>
              <b-dropdown-item
                class="dropdownNavNoti"
                aria-role="listitem"
                >
                  <p>Não há notificações por enquanto aqui.</p>
              </b-dropdown-item>
            </div>
          </b-dropdown>
          <b-dropdown v-else position="is-bottom-left" aria-role="menu" class="notifications">
            <button class="button" slot="trigger">
              <b-icon class="fas fa-bell"></b-icon>
            </button>
              <b-dropdown-item
                class="dropdownNavNoti"
                aria-role="listitem"
                >
                  <p>Em Breve!</p>
              </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </nav>
  </section>
</template>
<script>
import NotificacaoService from "@/services/NotificacaoService";
import AuthService from "@/services/AuthService";
import store from "@/store";

export default {
  data() {
    return {
      notificacoes: [],
      cargo: store.getters.cargo,
      cargo_id: store.getters.cargo_id,
      name: store.getters.name,
      profile_picture: store.getters.profile_picture
    };
  },
  created() {
    switch(this.cargo){
      case 'aluno':
        NotificacaoService.AlunoIndex(this.cargo_id).then(result => {
          this.notificacoes = result.data;
        });
      break;
    }
  },
  methods: {
    logout() {
      this.isLoading = true;
      AuthService.logout({})

        .then(() => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "logout realizado com sucesso!",
            position: "is-top-right",
            type: "is-success"
          });
        })
        .catch(() => {})
        .finally(() => {});
    }
  },

  name: "internnav"
};
</script>
<style lang="scss" scoped>
.badge {
  position: absolute;
  top: 5px;
  right: 20px;
  padding: 0px 7px;
  border-radius: 50%;
  background: red;
  color: white;
}
</style>